import { ClientJS } from 'clientjs';
const client = new ClientJS();

export const IOS = 'iOS';
export const Android = 'Android';
export default client;
